export default "__VITE_ASSET__Diefewv6__"